// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6406d4f9","667":"8256302a"}[chunkId] + ".chunk.js";
};